import type { Constraint, StationeryProduct } from '@shared/utils/print-price/types';
import { isArray } from 'lodash-es';
import { useMemo } from 'react';

export const POTENTIALLY_FREE_SHIPPING_COUNTRIES: ReadonlyArray<string> = ['US'];

/**
 * Determines which countries are eligible for free shipping based on product shipping options
 * @param products Array of StationeryProduct objects to check for free shipping eligibility
 * @returns Array of country codes that are eligible for free shipping
 */
export const useFreeShippingCountries = (products: StationeryProduct[]) => {
  return useMemo(() => {
    return POTENTIALLY_FREE_SHIPPING_COUNTRIES.filter(country => {
      return products.some(product => {
        const freeShippingOptions = product.shippingOptions?.filter(option => option.pricing.__typename === 'StationeryFlatFeePricing' && option.pricing.priceInMinorUnits === 0);

        return freeShippingOptions?.some(option => {
          const countryConstraints = option.constraints.filter(c => c.__typename === 'StationeryCountryShippingConstraint') as (Constraint & {
            __typename: 'StationeryCountryShippingConstraint';
          })[];

          return countryConstraints.some(constraint => {
            if (constraint?.excludedCountries?.includes(country)) {
              return false;
            }

            if (isArray(constraint?.includedCountries) && !constraint.includedCountries.includes(country)) {
              return false;
            }

            return true;
          });
        });
      });
    });
  }, [products]);
};
